import {CREATE_NORMAL_ONBOARDING, GET_BY_PROJECT_ID} from "./type";

const initiateState = {
    normalOnboarding: {},
    projectDetails: {}
}

const NormalOnboarading = (state = initiateState, action) => {
    const {type, payload} = action

    switch (type){
        case GET_BY_PROJECT_ID:
            return {
                ...state,
                payload: payload
            }
        case CREATE_NORMAL_ONBOARDING :
            return {
                ...state,
                payload: payload
            }
        default:
            return {
                ...state
            }
    }
}

export default NormalOnboarading